import { Fragment } from "react/jsx-runtime";
import { Input, InputGroup, InputGroupText } from "reactstrap";
import { dynamicImage, dynamicNumber, Image } from "../../../../../Utils";
import { Href } from "../../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { changeChat, createNewChatAsync } from "../../../../../ReduxToolkit/Reducers/Messenger/Chat";

const GroupChat = () => {
  const { chatMembers, currentUser, chats, selectedUser } = useAppSelector((state) => state.chat);
  const dispatch = useAppDispatch();
  var activeChat = 0;
  if (selectedUser != null) activeChat = selectedUser.id;
  const changeChatClick = (selectUser: number) => {
    const currentUserId = currentUser?.id;
    const currentChat = chats.find((x: { users: number[] }) => currentUser?.id !== undefined && x.users.includes(currentUser?.id) && x.users.includes(selectUser));
    if (currentChat) dispatch(changeChat(selectUser));
    else dispatch(createNewChatAsync({ currentUserId, selectUser, chats }));
  };
  return (
    <Fragment>
      <div className="search2 border-0">
        <div>
          <InputGroup>
            <div className="input-group-append">
              <InputGroupText><i className="fa fa-search" /></InputGroupText>
            </div>
            <Input type="text" placeholder="Start Chat" />
          </InputGroup>
        </div>
      </div>
      <ul className="group-main">
        {chatMembers
          .slice(8)
          .filter((x) => x.id !== currentUser?.id)
          .map((chatList, index) => (
            <li className={activeChat === chatList.id ? "active" : ""} key={index} onClick={() => changeChatClick(chatList.id)}>
              <div className="group-box">
                <div className={`profile ${chatList.onlineStatus}`}>{chatList.thumb ? <Image className="bg-img img-fluid" src={dynamicImage(chatList.thumb)} alt="Avatar" /> : <span>{chatList.name.split(" ").map((name) => name[0])}</span>}</div>
                <div className="details">
                  <h4>{chatList.name}</h4>
                  <h6>{chatList.mesg}</h6>
                </div>
                <div className="date-status">
                {index + 1 < 3 && (
                  <ul className="grop-icon">
                    {dynamicNumber(3).map((item, index) => (
                      <li key={index}>
                        <a className="group-tp" href={Href}>
                          <Image src={dynamicImage(`contact/${item}.jpg`)} alt="group-icon-img" className="img-fluid" />
                        </a>
                      </li>
                    ))}
                    <li>+ 35</li>
                  </ul>
                )}
                </div>
              </div>
            </li>
          ))}
      </ul>
    </Fragment>
  );
};

export default GroupChat;
